import { APP_BASE_HREF } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, ViewEncapsulation, HostListener, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { HeaderComponent } from '@app/_core/components/header/header.component';
import { ResponseHandler } from '@app/_core/helper/ResponseHandler';
import { Utils } from '@app/_core/helper/Utils';
import { AppService } from '@app/_core/services/app.service';
import { DialerService } from '@app/_core/services/dialer.service';
import { ManagerService } from '@app/_core/services/manager.service';
import { QueuesService } from '@app/_core/services/queues.service';
import { TmQueueService } from '@app/_core/services/tm-queue.service';
import { WebStorageService } from '@app/_core/services/webstorage.service';
import { CaseLockConfirmationComponent } from '@app/pages/common/case-lock/case-lock.component';
import { FilterDialogComponent } from '@app/pages/common/filter-dialog/filter-dialog.component';
import { ShowHideDialogComponent } from '@app/pages/common/show-hide-dialog/show-hide-dialog.component';
import { HubService } from '@app/pages/hubs/common/HubService';
import { Device } from '@twilio/voice-sdk';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { EMPTY, catchError, filter, map, fromEvent, debounceTime } from 'rxjs';
import { Subscription } from 'rxjs';
import { ConfirmDialogComponent } from 'src/app/pages/common/confirm-dialog/confirm-dialog.component';
import { MainControllerComponent } from 'src/app/pages/queue/dialer/MainController.component';
import { HeaderService } from '@app/_core/services/header.service';
import { AddRecordComponent } from '../common/case-detail/cases/add-record/add-record.component';
import { CreateCaseComponent } from '../common/case-detail/cases/create-case/create-case.component';
import { Queue } from '../dialer/Queue';
import { FlexibleStoreService } from '@app/_core/services/flexible-storage.service';
import { Table } from 'primeng/table';
let sub: any;
let sub1: any;
let sub2: any;
let softPhoneInitializing = false;
let QueueInteractionType: any = '';
let queueDialerType: any = '';
@Component({
  selector: 'app-outbound',
  templateUrl: './outbound.component.html',
  styleUrls: ['./outbound.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class OutboundComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild(Table) table: Table;
  private recordAddedSub: Subscription;
  private scrollSub: Subscription;
  softPhone: boolean = false;
  //selectedQuequId: number;
  queueList: any = [];
  dataToDisplay: any = [];
  filteredData: any = [];
  localStorageName = 'Queues-QueuesColumnDisplaySettings';
  headercount: any = { shown: 0, hidden: 0 };
  innerHeight = 10;
  modalRef?: BsModalRef;
  selectedFilterByField: any = '';
  filterVal: any = '';
  cols: any;

  automatedQueue = false;
  cloned: any;
  loadQueue: any;
  normalPriorityColors: string[] = ['#E99E1D', '#E99E1D', '#E99E1D', '#FFFFFF', '#FFFFFF'];
  lowPriorityColors: string[] = ['#2DB81F', '#2DB81F', '#FFFFFF', '#FFFFFF', '#FFFFFF'];
  highPriorityColors: string[] = ['#B81F2D', '#B81F2D', '#B81F2D', '#B81F2D', '#FFFFFF'];
  criticalPriorityColors: string[] = ['#9B0411', '#9B0411', '#9B0411', '#9B0411', '#9B0411'];
  token: any;
  enableAnswerCallBtn: boolean = false;
  clientAbbreviation: any = '';
  selectedQueueId: any;
  selectedQueueDetail: any;
  enableAddRecord: boolean = false;
  enableCaseCreation: boolean = false;
  callTimer: any;
  inboundCallDetails: any;
  twilioOptions: any;
  device: any;
  callId: any = '';
  connection: any;
  callDisconnected: boolean = false;
  queueColumns: any;
  automatedInbound = false;
  pageRefresh = true;
  isDialerCancelled = false;
  inbound: any;
  newCallSnd = new Audio('https://common.cts-connect.com/Audio/ding-ding.ogg');
  ShowManualInboundcallAlert: boolean = false;
  IncomingCallAlerttext: any = '';
  countdownField: any = '';
  callAlertInterval: any = null;
  ActionItemID: any = '';
  first = 0;
  totalRecords: number = 0;
  loading: boolean;
  rows: number = 20; // Records per batch for infinite scroll (configurable)
  hasMoreData: boolean = true; // Track if more data is available
  isLoadingMore: boolean = false; // Track if currently loading more data
 // rows: number = 10; // Records per page
  //hasMoreData: boolean = true; // Track if more data is available
  //isLoadingMore: boolean = false; // Track if currently loading more data
  isClearingFilters = false;
  conference: any;
  subs: any;
  clearInterval: boolean = false;
  addSearchParameterArray: any[];
  queueID: string;
  sortByColumnName: string = 'ID';
  sortByColumnDescend: boolean = false;
  filterDict: any = null;
  filterOptionRequestColumn: string = null;
  columnFilterClicked: boolean = false;
  companyCode: string;
  allLoadedItems: any[] = []; // Accumulates all items loaded via infinite scroll for column filter population
  private timeoutIds: any[] = [];
  constructor(
    private managerService: ManagerService,
    private dialerService: DialerService,
    private tmQueueService: TmQueueService,
    private webStorage: WebStorageService,
    private queueServices: QueuesService,
    private modalService: BsModalService,
    private utils: Utils,
    private router: Router,
    private appService: AppService,
    private route: ActivatedRoute,
    private headerComponent: HeaderComponent,
    private hubService: HubService,
    private headerService: HeaderService,
    private confirmDialogComponent: ConfirmDialogComponent,
    private mainController: MainControllerComponent,
    private cd: ChangeDetectorRef,
    private flexStore: FlexibleStoreService,
    private webStorageService: WebStorageService,
    @Inject(APP_BASE_HREF) public baseHref: string
  ) {
    this.companyCode = Utils.fetch('clientAbbreviation');
    this.appService.selectedQueueId.subscribe(value => {
      //console.log('selectedQueueId', value);
      if (value) {
        this.selectedQueueId = value;
      }
    });
    if (localStorage.getItem('pageRefreshed') === 'true') {
      console.log('~~~~~~~Page was refreshed');
      // Add your logic here
      // localStorage.setItem('urlB4Refresh', window.location.href);
      this.clientAbbreviation = this.webStorage.getItemFromSessionStorage('clientAbbreviation');
      this.router.navigate([this.clientAbbreviation + '/Queue']);
      // const selectedQuequId: any = localStorage.getItem('qid');
      //localStorage.removeItem('pageRefreshed');
      // this.selectedQuequId = selectedQuequId;
    }
    // this.loadQueues();
    //this.hubService.InboundCallEvents.subscribe((value: any) => {
    //  if (value && (value.eventName == 'OUTBOUND_CALL' || value.eventName == 'INBOUND_CALL')  && !this.mainController.getisCaseDetailStatus()) {
    //    console.log('outbound inbound call received', value.data);
    //    // _userDetails = value.data;
    //    this.eInboundCallHandler(value.data);
    //  } 
    //});
    //this.loadQueues();
  }

  ngOnInit() {
    this.queueServices.SetUnsubmittedCaseForReadonly(false);
    if(this.companyCode == 'BCH' || this.companyCode == 'PCH' || this.companyCode == 'AHP'){
      let isDataPresent = JSON.parse(this.flexStore.get('sciData'));
      if (!isDataPresent || isDataPresent?.length === 0) {
        this.queueServices.getSCIData();
      }
    }
      this.appService.adjustTimer();
    this.dialerService.setHoldCallDuration("0:00");
    this.queueServices.SetVoicemailDetailsReplyForChangeUser(false);
    this.headerService.answerInboundCall$.subscribe((value: any) => {
      if (value && !this.mainController.getisCaseDetailStatus()) {
        this.answerInboundNextCall();
        this.headerService.triggerAnswerInboundCall(null);
      }
    });

    this.headerService.rejectInboundCall$.subscribe((value: any) => {
      if (value && !this.mainController.getisCaseDetailStatus()) {
        this.rejectCall();
        this.headerService.triggerRejectInboundCall(null);
      }
    });

    // this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
    //   console.log('Navigation ended:', event);
    //   this.loadQueues();
    // });
    this.queueServices.SetDisableHeader(false);
    // let queueLoadedOnInit = true;
    this.recordAddedSub = this.managerService.recordAdded.subscribe(() => {
      this.loadQueues();
    });

    this.queueServices.getQueueColumns(this.selectedQueueId).subscribe(data => {
      this.cols = data.Response.Data;
      this.cols.forEach(col => {
        col.name = col.Name;
        col.label = col.Label;
      });
      // console.log(this.cols);
      this.initializeColumnHeader();
    });

    //this.queueServices.isTaskMenuQueueSelected.subscribe((value: any) => {
    //  if (value.queueType == 'Outbound' && !this.GetIsPageLoadCompleted()) {
    //    //if (value) {
    //    this.pageRefresh = value.pageRefresh;
    //    //}
    //    //else {
    //    // this.isPageInitCompleted = true;
    //    this.SetIsPageLoadCompleted(value.isPageInitCompleted);
    //    // this.SetIsPageLoadCompleted = value.SetIsPageLoadCompleted;
    //    //}
    //    if (this.pageRefresh && !this.GetIsPageLoadCompleted()) {
    //      this.isDialerCancelled = false;
    //      this.SetDialerCancelledStatus(false);
    //      this.doPageInit();
    //      // this.isPageInitCompleted = true;
    //      this.SetIsPageLoadCompleted(true);
    //      this.pageRefresh = false;
    //      // this.queueServices.setTaskMenuQueueSelected(false);
    //    }
    //  }
    //});

    this.queueServices.isInboundCallConnected.subscribe((value: any) => {
      if (value && !value.isInbound) {
        this.setAnswerInboundCalldata(value.data);
        this.queueServices.setisInboundCallConnected(null);
      }
    });
    this.dialerService.callDisconnected.subscribe((val: boolean) => {
      if (val) {
        this.callDisconnected = true;
      }
    });

    this.queueServices.selectedTaskMenuQueue.subscribe(response => {
      if (response?.menuName?.queue) {
        this.enableAddRecord = response.menuName.queue.EnableAddRecord;
        this.enableCaseCreation = response.menuName.queue.EnableCaseCreation;
      }
    });
    //}
    //      if (this.pageRefresh && !this.GetIsPageLoadCompleted())
    this.doPageInit();
    this.flexStore.remove('CaseCreatedForDifferentUser');
    this.flexStore.remove('DifferentUserCasesForTransfers');
    this.flexStore.remove('NewUserCases');
    this.queueServices.setValueParentChk(true);
    this.queueServices.setValueChildChk(false);
  }
ngAfterViewInit() {
  // Set up scroll listener for infinite scroll after view is initialized
  this.timeoutIds.push(
    setTimeout(() => {
      if (this.table && this.table.el) {
        // Find the scrollable wrapper element within PrimeNG table
        const scrollableView = this.table.el.nativeElement.querySelector('.p-datatable-scrollable-body');
        
        if (scrollableView) {
          console.log('Scroll container found:', scrollableView);
          this.scrollSub = fromEvent(scrollableView, 'scroll')
            .pipe(debounceTime(200))
            .subscribe((event: any) => {
              console.log('Scroll event triggered');
              this.onScroll(event);
            });
        } else {
          console.warn('Scroll container not found. Trying alternative selectors...');
          // Try alternative selector
          const altScrollView = this.table.el.nativeElement.querySelector('.p-datatable-wrapper');
          if (altScrollView) {
            console.log('Alternative scroll container found:', altScrollView);
            this.scrollSub = fromEvent(altScrollView, 'scroll')
              .pipe(debounceTime(200))
              .subscribe((event: any) => {
                console.log('Scroll event triggered (alt)');
                this.onScroll(event);
              });
          } else {
            console.error('No scrollable container found in table');
          }
        }
      } else {
        console.error('Table element not found');
      }
    }, 1000) // Increased timeout to ensure table is fully rendered
  ); 
}  
doPageInit() {
      this.filterVal = localStorage.getItem('queueSearchVal') || ''; 
      this.appService.setUserStatus(6, this.selectedQueueId);
      this.webStorageService.setItemInSessionStorage('previousUserStatus', 6);
     this.clientAbbreviation = Utils.fetch('clientAbbreviation');
    //console.log(this.clientAbbreviation);

    this.mainController.setactionItemToReturn(null);
    this.selectedQueueId = this.selectedQueueId ?? localStorage.getItem('qid');
    if (!this.queueServices.getisEscalatedCases()) {
      this.getQueueInfo(this.queueServices.getselectedQueueId());
    }
    this.releaseLocks();
    
    this.setCurrentQueue(this.selectedQueueId);
    this.mainController.setisCaseDetail(false);

    //this.dialerService.setUserStatus('In Queue (Ready)');

    this.tmQueueService.getQueueColumns(this.selectedQueueId).subscribe(data => {
      // display data in grid
      // console.log("getQueueColumns response", data)
      this.queueColumns = data.Response.Data;
      this.headerComponent.getBasicAgentStats();
      
      // Load initial queue data after columns are loaded
      this.loadQueues();
    });

    this.dialerService.callDisconnected.subscribe(value => {
      if (value) {
        // this.isPageInitCompleted = false;
        this.SetIsPageLoadCompleted(false);
        if (!this.dialerService.getIsTransferCallRejected()) {
          console.log('Twilio.Device - Reset');
          //this.mainController.disconnectTwilio();
        } else {
          console.log('getIsTransferCallRejected - Reset');
          // this.mainController.resetSoftPhone();
        }

      }
    });

    this.dialerService.muteMic.subscribe(value => {

      this.mainController.muteUnmuteMic(value);
    });

    this.dialerService.resetTimer.subscribe((val: boolean) => {
      if (val) {
        clearInterval(this.callTimer);
      }
    });

    //this.dialerService.onHold.subscribe((val: boolean) => {
    //    if (val) {
    //        this.tmQueueService.holdCall(this.queueServices.getCallID(), true).subscribe(data => {
    //            console.log(data);
    //        });
    //    }
    //});

    //this.dialerService.resumeCall.subscribe((val: boolean) => {
    //    if (val) {
    //        this.tmQueueService.resumeCall(this.queueServices.getCallID(), true, false, '').subscribe(data => {
    //            console.log(data);
    //        });
    //    }
    //});
  }
  HandleLock() {
    clearInterval(this.loadQueue);
    this.loadQueue = setInterval(() => {
      if (this.clearInterval)
        clearInterval(this.loadQueue);
      else
        this.getLocks();
    }, 10000);
  }

  ngOnDestroy() {
    this.queueServices.setTransferFlag(false);
    this.clearInterval = true;
    this.subs?.unsubscribe();
    clearInterval(this.loadQueue);
    clearInterval(this.callAlertInterval);
    
    // Cleanup scroll subscription
    if (this.scrollSub) {
      this.scrollSub.unsubscribe();
    }
    
    if (this.dialerService.getIsFreeDialer() && this.callDisconnected) {
      this.dialerService.setIsFreeDialer(false);
      this.dialerService.setResetCallSummary(true);
    }

    // Clear all timeouts safely
    this.timeoutIds.forEach(id => clearTimeout(id));
    this.timeoutIds = [];
  }

  Predictiveclose = function (): void {
    console.log('Predictive Close Called');
    window.clearTimeout(this.checkConnectedTimer);
    clearTimeout(this.waitingTimeout);
  };

  GetIsPageLoadCompleted() {
    const p1 = this.queueServices.getIsPageLoadCompleted();
    return p1;
  }
  //setUserStatus(statusId, queueId) {
  //  this.tmQueueService.setUserStatus(statusId, queueId).subscribe(data => {
  //    //console.log("setUserStatus response", data);
  //  });
  //}

  releaseLocks() {
    this.tmQueueService.releaseLocks().subscribe();
  }

  rejectCall() {
    this.headerService.setManualInboundCallAlert({
      show: false,
      incomingCallAlertText: '',
    });
    this.rejectInboundCall(this.queueServices.getCallID());
    //this.dialerService.setcallEnded(true);
    this.cancelCall();//it will cancel the other agent call who are in active
    this.ShowManualInboundcallAlert = false;
    this.headerService.setManualInboundCallAlert({
      show: false,
      incomingCallAlertText: this.IncomingCallAlerttext,
    });
    if (this.callAlertInterval) clearInterval(this.callAlertInterval);
  }

  rejectInboundCall(_callId) {
    this.tmQueueService.rejectCall(_callId).subscribe(data => {
      //console.log("isInboundCallConnected response", data);
    });
    this.dialerService.setIsTransferCallRejected(true);
  }

  getNextCallDetails() {
    this.ActionItemID = this.queueServices.getselectedQueueId() + (this.conference ? '-conference_' : '-inbound_') + this.queueServices.getCallID();
  }

  answerInboundNextCall() {

    //this.headerService.setManualInboundCallAlert({
    //  show: false,
    //  incomingCallAlertText: '',
    //});

    if (this.callAlertInterval) clearInterval(this.callAlertInterval);
    if (this.ActionItemID === '') {
      this.selectedQueueId = this.selectedQueueId ?? localStorage.getItem('qid');
      this.getNextCallDetails();
    }
    //this.setCurrentActionItem(this.selectedQueueId, this.ActionItemID);
    const data: any = {};
    data.dialerType = queueDialerType;
    data.navigateURL = this.ActionItemID;
    data.interactionType = QueueInteractionType;
    this.mainController.CallCurrentActionItems(this.queueServices.getselectedQueueId(), data);
    // Answer inbound call API
    //this.tmQueueService
    //  .answerInboundCall(this.queueServices.getCallID(), this.queueServices.getselectedQueueId())
    //  .subscribe(data => {
    //    //    console.log('answerInboundCall response', data);
    //    //    this.dialerService.setShowDialer(true);
    //    //    this.dialerService.setPhoneNo(data.Response.Data.PhoneNumber); // for testing
    //    //    this.dialerService.setCallConnected(true); // Show timer

    //  });

    // Set user status 5
  }

  setAnswerInboundCalldata(data: any) {
    this.appService.setUserStatus(5, this.selectedQueueId);
    this.appService.setActionItemId(this.selectedQueueId + '-' + data.UserID + '-' + data.CaseID);
    this.setCurrentCallee(data.UserID);
    this.queueServices.SetDisableHeader(true);
    this.queueServices.setCaseDetailsLoaded(true);
    if (data.UserID) { this.router.navigate([Utils.fetch('clientAbbreviation') + '/Queue/caseDetails']); this.mainController.setSearchUserSelected(true); }
    else {
      this.appService.setActionItemId(this.queueServices.getselectedQueueId() + '-' + null + '-' + null);
      this.RedirectToCaseDetails(data);
    }
  }

  setCurrentActionItem(queueId, ActionItemID) {
    this.tmQueueService.setCurrentActionItem(queueId, ActionItemID).subscribe(data => {
      //console.log("setCurrentActionItem response", data);
      let EnableAICaseNotesTemplate = data.Response.Data?.EnableAICaseNotesTemplate || false;
      this.appService.setEnableAICaseNotesTemplate(EnableAICaseNotesTemplate);
      //this.appService.setEnableTemplateButton(EnableAICaseNotesTemplate);
      //this.dialerService.setShowDialer(true);
    });
  }

  RedirectToCaseDetails(data) {
    this.addSearchParameterArray = [];
    this.dialerService.setPhoneNo(data.PhoneNumber);
    this.queueServices.setQueueRoute(this.router.url);
    this.addSearchParameterArray.push({
      type: 'Phone #',
      value: data.PhoneNumber,
    });
    console.log('outbound->RedirectToCaseDetails');
    this.queueServices.findRecord(this.addSearchParameterArray)
      .pipe(
        map((data: any) => {
          if (data.Response.Data != null && (data.Response.Data.length > 1 || data.Response.Data.length == 0)) {
            console.log('outbound->RedirectToCaseDetails->response ConfirmUser');
            this.appService.setActionItemId(this.queueServices.getselectedQueueId() + '-' + null + '-' + null);
            this.router.navigate([Utils.fetch('clientAbbreviation') + '/Queue/ConfirmUser']);
          } else {
            console.log('outbound->RedirectToCaseDetails->response caseDetails');
            this.appService.setActionItemId(this.queueServices.getselectedQueueId() + '-' + data.Response.Data[0].UserID + '-' + null);
            this.router.navigate([Utils.fetch('clientAbbreviation') + '/Queue/caseDetails']);
          }
        }),
        catchError(error => {
          console.log(error);
          return EMPTY;
        })
      )
      .subscribe();
  }

  SetDialerCancelledStatus(val) {
    this.dialerService.setDialerCancelledStatus(val);
  }

  inboundCallAlert = function (callDetails) {
    // console.log('row select', data);
    //let tempArr = data.ActionItemID.split("_");
    //this.callId = callDetails.find(i => i.key === 'callID').value;
    // this.selectedInboundCall = data;
    // this.ActionItemID = data.ActionItemID;
    //this.enableAnswerCallBtn = true;
    // console.log("enableAnswerCallBtn", this.enableAnswerCallBtn);
    //this.setCurrentActionItem(this.selectedQueueId, this.ActionItemID);
    //this.answerNextCall();
    if (!this.postCall) {
      this.mainController.callEnded_phnctrl();
    }
    this.ShowManualInboundcallAlert = true;

    let Number = callDetails.find(i => i.key === 'number').value,
      name = Utils.cleanString(callDetails.find(i => i.key === 'name').value),
      queue = Utils.cleanString(callDetails.find(i => i.key === 'queue').value),
      _callId = callDetails.find(i => i.key === 'callID').value,
      queuedTime = this.convertServerDate(callDetails.find(i => i.key === 'queuedTime').value),
      //now = this.convertServerDate(callDetails.find(i => i.key === 'CurrentTime').value),
      now = 0,
      secondsRemaining = Math.floor(Math.min(60, 90 - (now - queuedTime) / 1000)),
      conference = callDetails.find(i => i.key === 'conference').value;

    this.callId = _callId;
    // this.queueServices.setCallID(_callId);
    console.log('Outbound inboundCallAlert CALLID:' + this.queueServices.getCallID());
    this.newCallSnd.play();
    if (!conference) {
      this.countdownField = '00:' + (secondsRemaining < 10 ? '0' : '') + secondsRemaining;
      // btnView.addSubView(countdownField);
    }

    this.IncomingCallAlerttext =
      'Incoming ' +
      (conference ? 'conference with ' : 'call from ') +
      (Number == null ? '' : Number) +
      (name && name != '' ? ' - ' + name : '') +
      (queue && queue != '' ? ' (' + queue + ')' : '') +
      (this.postCall ? ' - Finish the current call to answer.' : '');
    //notification = cls.showNotification({
    //    text: text,
    //    bgColor: conference || postCall ? '#89EBE1' : '#FBF301',
    //    view: postCall ? null : btnView,
    //    timeout: false,
    //    clickToClose: false
    //});
    if (this.callAlertInterval) clearInterval(this.callAlertInterval);
    this.callAlertInterval = setInterval(() => {
      secondsRemaining--;
      this.countdownField = '00:' + (secondsRemaining < 10 ? '0' : '') + secondsRemaining;
      this.headerService.setCountdownField(this.countdownField);
      this.headerService.setManualInboundCallAlert({
        show: true,
        incomingCallAlertText: this.IncomingCallAlerttext,
      });
      if (secondsRemaining <= 0) {
        // notification.close();
        clearInterval(this.callAlertInterval);
        this.ShowManualInboundcallAlert = false;
        this.headerService.setManualInboundCallAlert({
          show: false,
          incomingCallAlertText: this.IncomingCallAlerttext,
        });
        this.rejectInboundCall(this.queueServices.getCallID());
        // im.InteractionService.instance().RejectCall({ callID: call.CallID };
      }
    }, 1000);
  };

  convertServerDate = function (date) {
    if (!date) return null;
    const dateFormat = /\/Date\(.*\)\//gi;
    if (dateFormat.test(date)) return new Date(parseInt(date.replace('/Date(', '').replace(')/', '')));
    else return new Date(date);
  };

  eInboundCallHandler = function (callDetails) {
    this.inboundCallAlert(callDetails);
  };

  eRealTimeCallEndedHandler = function (e) {

    this.dialerService.setShowDialer(false);
    this.SetIsPageLoadCompleted(false);
    this.queueServices.setCaseDetails_ENABLECONTROLS(false);
  };

  setCurrentCallee(userID: any) {
    this.tmQueueService.setCurrentCallee(this.queueServices.getCallID(), userID).subscribe(data => {
      console.log('setCurrentCallee response', data);
    });
  }

  setCurrentQueue(queueId) {
    this.tmQueueService.setCurrentQueue(queueId).subscribe(data => {
      //console.log("setCurrentQueue response", data);
    });
  }

  getInboundStatus(queueId, showLoader) {
    this.tmQueueService.getInboundStatus(queueId, showLoader).subscribe(data => {
      //console.log("getInboundStatus response", data);
    });
  }


  getVoicemailCountByStatus(agentID, status) {
    this.tmQueueService.getVoicemailCountByStatus(agentID, status).subscribe(data => {
      //console.log("getVoicemailCountByStatus response", data);
    });
  }

  getFailureDispositions() {
    this.tmQueueService.getFailureDispositions().subscribe(data => {
      //console.log("getFailureDispositions response", data);
    });
  }

  getExternalNumbersByActivity(queueId) {
    this.tmQueueService.getExternalNumbersByActivity(queueId).subscribe(data => {
      //console.log("GetExternalNumbersByActivity response", data);
    });
  }

  getUserStatus(queueId) {
    this.tmQueueService.getUserStatus(queueId).subscribe(data => {
      //console.log("getUserStatus response", data);
    });
  }

  SetIsPageLoadCompleted(val) {
    this.queueServices.setIsPageLoadCompleted(val);
  }

  showPhoneMessaging = function (message: string): void {

    this.dialerService.setdialerMessage(message);
  };

  getQueueInfo(queueId: any) {
    // // this.loaderService.display(true);
    //this.mainController.initializeSoftPhone();
    this.mainController.GetqueueDetails(queueId, this.automatedQueue).then(res => {
      let det: any;
      det = res;
      queueDialerType = det.dialerType;
      QueueInteractionType = det.interactionType;
      this.dialerService.setDeviceReady(true);
     // this.appService.setUserStatus(6, this.selectedQueueId);
    });
  }



  initializeColumnHeader() {
    const localCol = this.webStorage.getItemFromLocalStorage(this.localStorageName);
    //console.log('localCol', localCol);
    if (localCol != null) {
      this.cols = localCol;
    } else {
      //console.log('this.cols', this.cols);
      for (const col of this.cols) {
        col.hide = false;
      }
      this.webStorage.setItemInLocalStorage(this.localStorageName, this.cols);
    }
    this.getColumnCount();
  }

  getColumnCount() {
    let shown = 0;
    let hidden = 0;
    for (const header of this.cols) {
      if (header.hide) {
        hidden++;
      } else {
        shown++;
      }
    }
    this.headercount.shown = shown;
    this.headercount.hidden = hidden;
  }

  /*globalFilter*/
  clearSearchBox() {
    this.filterVal = '';
    this.first = 0;
    this.loadQueueData(null);
  }
  clearSearch() {
    this.filterVal = '';
    localStorage.removeItem('queueSearchVal');
    if (!this.filterDict || this.filterDict.length === 0)
       this.rebuildFilterDictFromCols();
    this.applyFilterByField();
  }

  resetTable() {
    this.first = 0;
    this.hasMoreData = true;
    this.isLoadingMore = false;
    this.allLoadedItems = [];
  }

  applyFilterByField() {
    localStorage.setItem('queueSearchVal', this.filterVal);
     this.first = 0; 
    localStorage.removeItem('_pl'); // Clear cached payload
    // Reset pagination when applying filters
    this.first = 0;
    this.hasMoreData = true;
    this.isLoadingMore = false;

    // console.log("Apply filter by field", this.selectedFilterByField.value, this.filterVal);
    if (this.filterVal.length >= 3) {
      this.loadQueueData(null);
    }

    if (this.filterVal.length == 0) {
      if (!this.filterDict || this.filterDict.length === 0) {
        this.rebuildFilterDictFromCols();
      }
      // Clear search and reload data
      if (this.filterDict && this.filterDict.length > 0) {
        this.loadQueueData(this.filterDict);
      }
      else
      {
      this.loadQueueData(null);
      }
    }
  }

  findByMatchingProperties(set: any, properties: any, searchText: string) {
    // console.log(set, ' ', properties, ' ', searchText);
    return set.filter((entry: any) => {
      //   console.log(entry);
      if (properties == 'SEARCH_ALL_FIELDS') {
        for (const key in entry) {
          if (Object.prototype.hasOwnProperty.call(entry, key)) {
            // console.log(key + ' -> ' + entry[key]);
            if (entry[key]?.toString().toLowerCase().includes(searchText)) return entry;
          }
        }
      } else {
        if (typeof entry[properties.value] === 'number') {
          if (entry[properties.value].toString() == searchText) {
            return entry;
          }
        } else if (entry[properties.value].toString().toLowerCase().includes(searchText)) return entry;
      }
    });
  }

  /*column level filter - removed as backend handles filtering*/

  showHideColumns() {
    const initialState = {
      headerNames: this.cols,
      localStorageName: this.localStorageName,
    };

    const config: ModalOptions = { class: 'modal-wd-200', initialState };

    this.modalRef = this.modalService.show(ShowHideDialogComponent, config);
    this.modalRef.content.event.subscribe((result: any) => {
      this.initializeColumnHeader();
    });
  }
  sortByColumn(colObj: any) {
    this.sortByColumnName = colObj.name;
    this.sortByColumnDescend = !this.sortByColumnDescend;

    // Reset pagination and infinite scroll when sorting
    this.first = 0;
    this.hasMoreData = true;
    this.isLoadingMore = false;

    for (const col of this.cols) {
      if (col.name == colObj.name) {
        colObj.isAsc = this.sortByColumnDescend;
      } else {
        delete col.isAsc;
      }
    }

    // Clear cached payload so the new sort values are not overwritten
    localStorage.removeItem('_pl');

    // Load data with new sorting
    this.loadQueueData(null);
  }

  onRowSelect(rowData) {

      if (this.getAgentStatus() != 5) {
          //5->oncall
          this.queueServices.setChildCallID('');
      }
    this.appService.setHasOpenedQNX(false);
    this.queueServices.setisEscalatedCases(false);
    this.queueServices.setFromSearchQueue(false);
    const companyCode = Utils.fetch('clientAbbreviation');
    const menuName = companyCode + '/Queue/caseDetails';
    const actionItemID = this.queueServices.getCaseDetails(menuName, rowData?.data);
    if (rowData.data.Locked) {
      //setting read only mode
      rowData.data.ActionItemID = actionItemID + '-R';
      const initialState = {
        selectedData: rowData.data,
      };
      const config: ModalOptions = {
        class: 'status-menu',
        backdrop: 'static',
        keyboard: false,
        initialState,
      };
      this.modalRef = this.modalService.show(CaseLockConfirmationComponent, config);
    } else {
      localStorage.setItem('selectedOutboundCase', JSON.stringify(rowData));
      this.dialerService.setcallEnded(false);
      this.appService.setActionItemId(actionItemID);
      // console.log({ activeRightPanelTabfromRow: true });
      this.router.navigate([menuName], { state: { activeRightPanelTabfromRow: true } });
      this.webStorageService.setItemInSessionStorage('previousUserStatus', 7)
      this.dialerService.setPhoneNo('');
    }
  }
    getAgentStatus() {
        let status = this.mainController.getAgentStatus();
        return status;
    }
  toggleCustomColumnFilter(colName: string) {
    this.columnFilterClicked = true;
    this.filterOptionRequestColumn = colName;
    this.filterDict = [];
    this.loadQueueData(null);
  }

  showColumnFilterModal(colName: string) {
    
    const initialState = {
      cols: this.cols,
      colName: colName,
    };
    const config: ModalOptions = { 
      class: 'task-menu', 
      initialState,
      backdrop: 'static',
      keyboard: false,
      animated: true
    };

    this.timeoutIds.push(
      setTimeout(() => {
        console.log('Opening modal with config:', config);
        this.modalRef = this.modalService.show(FilterDialogComponent, config);
        
        // Ensure backdrop is visible
        const backdrop = document.querySelector('.modal-backdrop');
        if (backdrop) {
          backdrop.classList.add('show');
        }

        this.modalRef.content.event.subscribe((result: any) => {
          console.log('Modal event received:', result);
          this.cols = result.data;
          this.applyColumnFilters();
        });
        
        this.cd.detectChanges();
      }, 0)
    );
  }

  applyColumnFilters() {
    this.columnFilterClicked = false;
    localStorage.removeItem('_pl'); // Clear cached payload
    this.webStorage.setItemInLocalStorage(this.localStorageName, this.cols);
    
    // Reset pagination and infinite scroll when filtering
    this.first = 0;
    this.hasMoreData = true;
    this.isLoadingMore = false;
    
    this.filterDict = [];
    this.filterOptionRequestColumn = null;
    
    for (const colData of this.cols) {
      const filterVals: string[] = [];
      if (colData.filterVals && colData.filterVals.length > 0) {
        for (const val of colData.filterVals) {
          if (val.checked) {
            // Handle null values - don't convert to string if null
            const valueToAdd = val.name != null ? val.name.toString() : "";
            filterVals.push(valueToAdd);
          }
        }
        this.filterDict.push({ Key: colData.name, Value: filterVals });
      }
    }
    
    this.loadQueueData(null);
  }

  hasActiveFilter(colName: string): boolean {
    const col = this.cols.find((c) => c.name === colName);
    if (!col || !col.filterVals) return false;
    
    return col.filterVals.some((fv: any) => fv.checked === true);
  }

  addRecord(event: any) {
    // console.log(event.target.id);
    const initialState = {
      Heading: 'Select a record to Add',
      reason: event.target.id,
    };
    const config: ModalOptions = { backdrop: 'static', class: 'add-menu', initialState };
    this.modalRef = this.modalService.show(AddRecordComponent, config);
    // this.modalRef.content.onClose = new Subject<boolean>();

    // this.modalRef.content.onClose.subscribe(result => {
    //   console.log(result,'outbound add rec')
    // })
    // this.modalRef.content.event.subscribe((result: any) => {
    //   this.initializeColumnHeader();
    // });
  }

  createCase(event: any) {
    // console.log(event.target.id);
    const initialState = {
      Heading: 'Select a record',
      reason: event.target.id,
    };
    const config: ModalOptions = { backdrop: 'static', class: 'add-menu', initialState };
    this.modalRef = this.modalService.show(CreateCaseComponent, config);

    // this.modalRef.content.event.subscribe((result: any) => {
    //   this.initializeColumnHeader();
    // });
  }
  // this.selectedFilterColumn = { name: colName }
  // this.filterVals = [];
  //  const unique = [...new Set(this.filteredData.map((item: any) => item[colName]))];
  //   this.filterVals = {colName:colName,filterVals:unique};

  setInnerWidthHeightParameters() {
    // this.innerWidth = window.innerWidth;
    this.innerHeight = window.innerHeight * 0.5;
  }

  loadQueues() {
    this.loading = true;
    this.loadQueueData(null);
  }

  loadQueueData(event: any, appendData: boolean = false) {
    // Prevent loading if already loading more data
    if (this.isLoadingMore && appendData) {
      return;
    }

    if (appendData) {
      this.isLoadingMore = true;
    } else {
      this.loading = true;
    }

    let currentPage = Math.floor(this.first / this.rows);

    // Build request payload matching historicalmetrics
    let payload: any = {
      rowOffset: this.first,
      rowCount: this.rows,
      currentUserOnly: false,
      isExport: false,
      queueID: this.selectedQueueId
    };

    // Override with event data if provided
    if (event != null) {
      payload.rowOffset = event.first;
      payload.rowCount = event.rows;
    }

    // Add search parameters
    if (this.filterVal) {
      payload.searchField = this.selectedFilterByField?.value || '';
      payload.searchValue = this.filterVal;
    } else {
      payload.searchField = '';
      payload.searchValue = '';
    }

    // Add column filters - send as array or empty array (not null)
    if (this.filterDict && Array.isArray(this.filterDict)) {
      payload.filterDict = this.filterDict;
    } else {
      payload.filterDict = [];
    }

    // Add sort parameters
    if (this.sortByColumnName) {
      payload.sortColumn = this.sortByColumnName;
      payload.sortDescend = this.sortByColumnDescend;
    }

    // Add filter option request if needed
    if (this.filterOptionRequestColumn) {
      payload.filterOptionRequestColumn = this.filterOptionRequestColumn;
    }

    if('_pl' in localStorage && !this.columnFilterClicked) { // Use cached payload to preserve filters/search/sort
      // cache payload, store in local storage/session storage and use it.
      const cachedPayload = JSON.parse(localStorage.getItem('_pl'));
      payload.rowOffset = event ? event.first : this.first;
      payload.searchField = cachedPayload.searchField;
      payload.searchValue = cachedPayload.searchValue;
      payload.filterDict = cachedPayload.filterDict;
      payload.sortColumn = cachedPayload.sortColumn;
      payload.sortDescend = cachedPayload.sortDescend;
    }else{
        localStorage.setItem('_pl', JSON.stringify(payload));
    }

    // When a column filter is requested, derive unique values from accumulated data and open modal directly
    if (this.filterOptionRequestColumn) {
      const requestedColumn = this.filterOptionRequestColumn;
      const col = this.cols.find((c) => c.name === requestedColumn);

      if (col && this.allLoadedItems.length > 0) {
        const existingCheckedValues = col.filterVals ?
          col.filterVals.filter((val: any) => val.checked).map((val: any) => val.name) : [];

        const uniqueValues = Array.from(new Set(this.allLoadedItems.map((item: any) => {
          const raw = item[requestedColumn];
          return (raw != null && raw !== '' && (typeof raw !== 'string' || raw.trim() !== ''))
            ? raw
            : null;
        })));

        col.filterVals = uniqueValues.map(val => ({
          name: val,
          checked: existingCheckedValues.includes(val)
        }));
      }

      this.filterOptionRequestColumn = null;
      this.loading = false;
      this.isLoadingMore = false;
      this.showColumnFilterModal(requestedColumn);
      return;
    }

    this.queueServices.dynamicGetActionItemPage(payload).subscribe({
      next: (data) => {
        const isValid = ResponseHandler.processResponse(data, 'GetActionItemPage');
        
        if (isValid) {
          // Handle normal data response
          const newItems = data.Response.Data.Items || [];
          this.totalRecords = data.Response.Data.TotalFilteredItems || 0;

          newItems.forEach(element => {
            element.Locked = element.LockingUserID ? element.Locked : false;
          });

          if (appendData) {
            // Append new data for infinite scroll
            this.queueList = [...this.queueList, ...newItems];
            this.dataToDisplay = [...this.dataToDisplay, ...newItems];
            this.filteredData = [...this.filteredData, ...newItems];
            this.allLoadedItems = [...this.allLoadedItems, ...newItems];
            
            // Check if there's more data to load
            this.hasMoreData = this.dataToDisplay.length < this.totalRecords;
          } else {
            // Replace data (initial load or filter/sort change)
            this.queueList = newItems;
            this.filteredData = newItems;
            this.dataToDisplay = newItems;
            this.allLoadedItems = [...newItems];
            this.hasMoreData = this.dataToDisplay.length < this.totalRecords;
          }

          this.loading = false;
          this.isLoadingMore = false;
          this.setInnerWidthHeightParameters();

          // Handle locks only if not first load
          if (currentPage === 0 && !this.filterVal && !appendData) {
            clearInterval(this.loadQueue);
            this.HandleLock();
          }

          if (localStorage.getItem('caseDetailsPageRefreshed')) {
            localStorage.removeItem('caseDetailsPageRefreshed');
            this.onRowSelect(JSON.parse(localStorage.getItem('selectedOutboundCase')));
          }

          this.cd.detectChanges();
        } else {
          // Handle invalid response
          this.loading = false;
          this.isLoadingMore = false;
          console.error('Invalid response from GetActionItemPage');
        }
      },
      error: (error) => {
        // Handle API error
        this.loading = false;
        this.isLoadingMore = false;
        console.error('Error loading queue data:', error);
      }
    });
  }

  onPageChange(event: any) {
    // This is now used for infinite scroll
    // Load more data when scrolling
    console.log('onPageChange called:', {
      hasMoreData: this.hasMoreData,
      isLoadingMore: this.isLoadingMore,
      currentLength: this.dataToDisplay.length,
      totalRecords: this.totalRecords
    });
    
    if (this.hasMoreData && !this.isLoadingMore) {
      this.first = this.dataToDisplay.length;
      const scrollEvent = {
        first: this.first,
        rows: this.rows
      };
      console.log('Loading next batch:', scrollEvent);
      this.loadQueueData(scrollEvent, true); // true = append data
    } else {
      console.log('Cannot load more:', {
        hasMoreData: this.hasMoreData,
        isLoadingMore: this.isLoadingMore
      });
    }
  }

  onScroll(event: any) {
    // Detect when user scrolls near the bottom
    const tableViewHeight = event.target.offsetHeight;
    const tableScrollHeight = event.target.scrollHeight;
    const scrollLocation = event.target.scrollTop;

    console.log('Scroll Debug:', {
      tableViewHeight,
      tableScrollHeight,
      scrollLocation,
      hasMoreData: this.hasMoreData,
      isLoadingMore: this.isLoadingMore,
      currentRecords: this.dataToDisplay.length,
      totalRecords: this.totalRecords
    });

    // When within 200px of bottom, load more
    const buffer = 200;
    const limit = tableScrollHeight - tableViewHeight - buffer;

    console.log('Scroll threshold check:', {
      limit,
      scrollLocation,
      shouldLoad: scrollLocation > limit
    });

    if (scrollLocation > limit && this.hasMoreData && !this.isLoadingMore) {
      console.log('Loading more data...');
      this.onPageChange(null);
    }
  }

  getLocks() {
    const records = this.dataToDisplay;
    this.queueServices.GetLocks().subscribe(data => {
      if (
        data.Response.Data != null &&
        data.Response.Data.length > 0 &&
        this.dataToDisplay != null &&
        this.dataToDisplay.length > 0
      ) {
        //To reset the locked status for all records to default
        this.dataToDisplay.forEach(displayrecord => {
          displayrecord.Locked = false;
          displayrecord.LockedBy = '';
        });

        //Set the locked status for the records based on CaseId or UserId
        this.dataToDisplay.forEach(displayRecord => {
          let IsMatchFound = false;
          data.Response.Data.forEach((lockedRecord, i) => {
            if (lockedRecord.CaseID) {
              if (lockedRecord.CaseID == displayRecord.CaseID) {
                IsMatchFound = true;
                displayRecord.Locked = true;
                displayRecord.LockedBy = lockedRecord.LockingUserID;
              }
            } else if (lockedRecord.UserID == displayRecord.UserID) {
              IsMatchFound = true;
              displayRecord.Locked = true;
              displayRecord.LockedBy = lockedRecord.LockingUserID;
            }
          });
          if (!IsMatchFound) {
            displayRecord.Locked = false;
            displayRecord.LockedBy = '';
          }
        });
      } else {
        if (this.dataToDisplay != null && this.dataToDisplay.length > 0) {
          this.dataToDisplay.forEach(displayRecord => {
            displayRecord.Locked = false;
            displayRecord.LockedBy = '';
          });
        }
      }
    });
  }

  cancelCall() {
    this.tmQueueService
      .CancelAttendedTransferAgentCall(this.queueServices.getCallID())
      .subscribe();
  }

  clearFilter() {
    this.isClearingFilters = true;
    this.filterVal = localStorage.getItem('queueSearchVal') || '';
    this.applyFilterByField();
    //this.filterVal = '';
    this.selectedFilterByField = '';
  
    if (Array.isArray(this.cols)) {
      this.cols = this.cols.map((c: any) => {
        const newCol = { ...c };
        newCol.filterVals = null;
        if ('isAsc' in newCol) delete newCol.isAsc;
        return newCol;
      });
  
      this.webStorage.setItemInLocalStorage(this.localStorageName, this.cols);
    }
  
    this.filterDict = [];
    this.filterOptionRequestColumn = null;
    this.columnFilterClicked = false;
  
    this.sortByColumnName = 'ID';
    this.sortByColumnDescend = false;
    this.first = 0;
    this.hasMoreData = true;
    this.isLoadingMore = false;
    localStorage.removeItem('_pl');
    (this as any).__skipPayloadHydrateOnce = true;
  
    try { this.modalRef?.hide(); } catch {}
  

    try {
      if (this.table) {
        (this.table as any).clear?.();
        const scrollable = this.table.el?.nativeElement?.querySelector('.p-datatable-scrollable-body');
        if (scrollable) scrollable.scrollTop = 0;
      }
    } catch {}
    this.loadQueueData(null);
    this.cd.detectChanges();
  }
  private rebuildFilterDictFromCols() {
    const dict = [];
    if (Array.isArray(this.cols)) {
      for (const col of this.cols) {
        if (col?.filterVals) {
          const selected = col.filterVals
            .filter(v => v.checked)
            .map(v => v.name ?? null);
          if (selected.length > 0) {
            dict.push({ Key: col.name, Value: selected });
          }
        }
      }
    }
    this.filterDict = dict;
  }
}
